import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const yupToFormErrors = (yupError) => {
  return _.reduce(yupError.inner, (result, err) => {
    result[err.path] = err.message
    return result
  }, {})
}

const validateYupSchema = (schema, values) => {
  return schema.validate(values, { abortEarly: false })
}

class Form extends React.Component {
  getChildContext() {
    return {
      form: {
        ...this.state,
        handleChange: this.handleChange,
        handleBlur: this.handleBlur
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {
      values: props.initialValues || {},
      errors: {},
      touched: {},
      isSubmitting: false
    }

    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
  }

  handleSubmit(e) {
    e.preventDefault()
    e.persist()

    this.setState({
      touched: _.mapValues(this.state.values, () => (true)),
      isSubmitting: true
    }, () => this.validate(this.state.values, () => e.target.submit()))
  }

  handleChange(e) {
    let { name, value} = e.target

    this.setState({
      values: { ...this.state.values, [name]: value }
    }, () => this.validate(this.state.values))
  }

  handleBlur(e) {
    this.setState({
      touched: { ...this.state.touched, [e.target.name]: true }
    }, () => this.validate(this.state.values))
  }

  validate(values, onSuccess) {
    return validateYupSchema(this.props.validationSchema, values)
      .then(
        () => {
          this.setState({ errors: {} })

          if (onSuccess) {
            onSuccess()
          }
        },
        (err) => {
          this.setState({
            errors: yupToFormErrors(err),
            isSubmitting: false
          })
        }
      )
  }

  render() {
    let { initialValues, validationSchema, ...other } = this.props

    return (
      <form onSubmit={this.handleSubmit} {...other}>
        {this.props.children}
      </form>
    )
  }
}

Form.propTypes = {
  initialValues: PropTypes.object.isRequired,
  validationSchema: PropTypes.object.isRequired
}

Form.childContextTypes = {
  form: PropTypes.object
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Form/index.js